{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.schaerding.softline",
  "name": "Softline"
}
